import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { selectOrgName } from 'app/_state/org-context/org-context-selectors';
import { OrgContextState } from 'app/_state/org-context/org-context-state';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
})
export class AdminHeaderComponent {
  organizationName$ = this.store.select(selectOrgName);
  constructor(
    private store: Store<OrgContextState>,
    public router: Router
  ) {
  }

}
